import { render, staticRenderFns } from "./ImagesTmpl.vue?vue&type=template&id=3060a706&scoped=true"
import script from "./ImagesTmpl.vue?vue&type=script&lang=js"
export * from "./ImagesTmpl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3060a706",
  null
  
)

export default component.exports